module.exports = __webpack_public_path__ + "img/imweb_design_6.9f43a637.png";